module.exports = __webpack_public_path__ + "img/expenditure_manage.1c7fad3b.png";